export const types = {
  SET_FEATURE_REQUESTS: "SET_FEATURE_REQUESTS",
  ADD_FEATURE_REQUEST: "ADD_FEATURE_REQUEST",
  UPDATE_FEATURE_REQUEST: "UPDATE_FEATURE_REQUEST",
  DELETE_FEATURE_REQUEST: "DELETE_FEATURE_REQUEST",
};

export const setFeatureRequests = payload => ({
  type: types.SET_FEATURE_REQUESTS,
  payload,
});

export const addFeatureRequest = payload => ({
  type: types.ADD_FEATURE_REQUEST,
  payload,
});

export const updateFeatureRequest = payload => ({
  type: types.UPDATE_FEATURE_REQUEST,
  payload,
});

export const deleteFeatureRequest = payload => ({
  type: types.DELETE_FEATURE_REQUEST,
  payload,
});
